<template>
    <div ref="container">
      <a-modal :top="20" :title="title" width="95%" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'2%','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:1%;height: 95%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <a-spin :spinning="confirmLoading">
          <a-form-model ref="form" :model="form" :rules="rules">
            <a-row class="form-row" :gutter="24">
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品名称" prop="productName">
                  <a-select
                    v-model="form.productName"
                    show-search
                    placeholder="输入文字进行搜索"
                    style="width: 100%"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :not-found-content="null"
                    @search="handleSearch"
                    @change="handleChange"
                  >
                    <a-select-option v-for="(item,index) in showMaterials" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="商品编码DI" prop="productCode">
                  <a-input placeholder="请输入商品编码" v-model="form.productCode" disabled/>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="规格型号" prop="model">
                  <a-input placeholder="请输入规格型号" v-model="form.model" disabled/>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产企业名称" prop="factory">
                  <a-input placeholder="请输入生产企业名称" v-model="form.factory" disabled/>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册/备案凭证号" prop="registerNo">
                  <span v-show="form.registerNo" style="margin-right: 40px;">{{ form.registerNo }}</span>
                  <a-button @click="gozhuce" type="primary">选择</a-button>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="医疗器械注册人/备案人名称" prop="registerNo">
                  <span v-show="form.registerNo" style="margin-right: 40px;">{{ form.registerName }}</span>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产批号" prop="batchNum">
                  <a-input placeholder="请输入生产批号" v-model="form.batchNum" />
                </a-form-model-item>
              </a-col>


              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单据编号" prop="code">
                  <a-input placeholder="请输入单据编号" v-model="form.code" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="召回日期" prop="recallDate">
                  <JDate placeholder="请填写召回日期" v-model="form.recallDate" ></JDate>
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="应召回数量" prop="recallNum">
                  <a-input placeholder="请输入应召回数量" v-model="form.recallNum" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="召回人" prop="recaller">
                  <a-input placeholder="请输入召回人" v-model="form.recaller" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="召回事由" prop="recallReason">
                  <a-input placeholder="请输入召回事由" v-model="form.recallReason" />
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="计价单位" prop="pricingUnit">
                  <a-input placeholder="请输入计价单位" v-model="form.pricingUnit" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="剂型/分类" prop="categorize">
                  <a-input placeholder="请输入剂型/分类" v-model="form.categorize" />
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="注册/备案证有效期至" prop="validTo">
                  <JDate placeholder="请输入注册/备案证有效期至" v-model="form.validTo" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产许可证号" prop="productionLicense">
                  <a-input placeholder="请输入生产许可证号" v-model="form.productionLicense" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="生产许可证有效期至" prop="manufacturingPermit">
                  <JDate placeholder="请输入生产许可证有效期至" v-model="form.manufacturingPermit" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="差额原因" prop="difference">
                  <a-input placeholder="请输入差额原因" v-model="form.difference" />
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="有效期" prop="expireDate">
                  <JDate placeholder="请填写有效期" v-model="form.expireDate" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="序列号" prop="serial">
                  <a-input placeholder="请输入序列号" v-model="form.serial" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="灭菌批号" prop="lotNumber">
                  <a-input placeholder="请输入灭菌批号" v-model="form.lotNumber" />
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="灭菌有效期至" prop="sterilizationExpiration">
                  <JDate placeholder="请输入灭菌有效期至" v-model="form.sterilizationExpiration" ></JDate>
                </a-form-model-item>
              </a-col>
              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="厂家物料编码" prop="materialCode">
                  <a-input placeholder="请输入厂家物料编码" v-model="form.materialCode" />
                </a-form-model-item>
              </a-col>

              <a-col :span="24/1">
                <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                  <j-image-upload v-model="fileList" bizPath="material" text="上传" isMultiple></j-image-upload>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </a-spin>
      </a-modal>
      <regModel ref="regModelref" @change="costPlannedAmountChange($event)"></regModel>
    </div>
  </template>
  <script>
  import JImageUpload from '@/components/jeecg/JImageUpload'
  import { certificateDetail, recallAdd, recallEdit,getAllMaterials } from '@/api/api'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JDate from '../../../components/jeecg/JDate.vue'
  import regModel from '@views/UDIadmin/modules/regModel.vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      regModel,
        JImageUpload,
        JDate,
    },
    data() {
      return {
        allMaterials:[],
        showMaterials:[],
        title: '操作',
        visible: false,
        fileList: '',
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        form: {
          registerName: '',
          registerNo: '',
          registerImage: '',
          materialId:'',
        },
        uploadHeaders: {},
        action: window._CONFIG['domianURL'] + '/systemConfig/upload',
        rules: {
          code: [{ required: true, message: '单据编号不可为空' }],
          recallDate: [{ required: true, message: '召回日期不可为空' }],
          productName: [{ required: true, message: '商品名称不可为空' }],
        },
        id: '',
      }
    },
    methods: {
      costPlannedAmountChange(value) {
        console.log(value, 'value---')
        this.form.registerNo = value.registerNoList.join(',')
        this.form.registerName = value.registerNameList.join(',')
      },
      gozhuce() {
        this.$refs.regModelref.add()
      },
      handleSearch(info){
        console.log('-111->>',info)
        this.showMaterials = this.allMaterials.filter(option=>option.name.indexOf(info)>-1)
      },
      handleChange(info) {
        const item = this.allMaterials.find(a=>a.id == info)
        console.log('-222->>',item)
        this.form.productCode = item.diCode
        this.form.model = item.standard
        this.form.factory = item.companyName
        this.form.materialId = item.id
      },
      add() {
        this.edit({})
      },
      edit(record) {

        getAllMaterials().then(res=>{
          this.allMaterials = res.result
          this.showMaterials = res.result
        })

        if (this.$refs.form !== undefined) this.$refs.form.resetFields()
        console.log(this.form, 'form')
        console.log(this.fileList, '数组')
        if (record.id) {
          this.getInfo(record.id)
          this.id = record.id
        } else {
          this.fileList = ''
        }
        this.visible = true
        this.$nextTick(() => {})
      },
      async getInfo(id) {
        this.confirmLoading = true
        const res = await certificateDetail({ id })
        console.log(res, 'res---')
        if (res.errno == 200 && res.errmsg == '成功') {
          this.form = res.data
          if (res.data.registerImage) {
            this.fileList = res.data.registerImage
          }
          this.confirmLoading = false
        } else {
          this.$message.error(res.data || res.errmsg)
          this.confirmLoading = false
        }
      },

      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        const that = this
        // 触发表单验证
        that.$refs['form'].validate(async (success) => {
          if (success === true) {
            console.log(this.form, 'form---')
            // console.log(this.fileList, '图片数组')
            // if (this.fileList.length == 0) return this.$message.warning('请上传至少一张图片')
            let params = {
              code: this.form.code || '',
              recallDate: this.form.recallDate || '',
              productCode: this.form.productCode || '',
              productName: this.form.productName || '',
              recallNum: this.form.recallNum || '',
              recaller: this.form.recaller || '',
              recallReason: this.form.recallReason || '',
              model: this.form.model || '',
              pricingUnit: this.form.pricingUnit || '',
              categorize: this.form.categorize || '',
              certificate: this.form.certificate || '',
              validTo: this.form.validTo || '',
              productionLicense: this.form.productionLicense || '',
              manufacturingPermit: this.form.manufacturingPermit || '',
              difference: this.form.difference || '',
              batchNum: this.form.batchNum || '',
              expireDate: this.form.expireDate || '',
              serial: this.form.serial || '',
              lotNumber: this.form.lotNumber || '',
              sterilizationExpiration: this.form.sterilizationExpiration || '',
              materialCode: this.form.materialCode || '',
              factory: this.form.factory || '',
              state: this.form.state || '',
              attachment: this.fileList || '',
              materialId:this.form.materialId
            }
            if (this.id) {
              // 编辑
              params.id = this.id
              const res = await recallEdit(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.handleCancel()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            } else {
              const res = await recallAdd(params)
              console.log(res, 'res')
              if (res.code == 200 && res.success == true) {
                this.$message.success(res.result)
                this.close()
              } else {
                this.$message.error(res.data || res.errmsg)
              }
            }
          }
        })
      },
      handleCancel() {
        this.close()
      },
      validateSupplierName(rule, value, callback) {
        let params = {
          name: value,
          type: '供应商',
          id: this.model.id ? this.model.id : 0,
        }
        checkSupplier(params).then((res) => {
          if (res && res.code === 200) {
            if (!res.data.status) {
              callback()
            } else {
              callback('名称已经存在')
            }
          } else {
            callback(res.data)
          }
        })
      },
    },
  }
  </script>
  <style scoped>
  </style>